(function () {
  function initCarousel(root) {
    if (root.dataset.zerivaMediaReady === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-zeriva-media-slide]'));
    if (!slides.length) return;
    root.dataset.zerivaMediaReady = 'true';
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-zeriva-media-dot]'));
    var current = 0;
    var touchStart = null;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) { slide.hidden = slideIndex !== current; });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === current);
        if (dotIndex === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    var previous = root.querySelector('[data-zeriva-media-previous]');
    var next = root.querySelector('[data-zeriva-media-next]');
    if (previous) previous.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { show(Number(dot.dataset.zerivaMediaDot || 0)); });
    });
    root.addEventListener('touchstart', function (event) { touchStart = event.touches[0] ? event.touches[0].clientX : null; }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (touchStart === null) return;
      var end = event.changedTouches[0] ? event.changedTouches[0].clientX : touchStart;
      if (Math.abs(end - touchStart) > 45) show(current + (end < touchStart ? 1 : -1));
      touchStart = null;
    }, { passive: true });
    show(0);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-zeriva-media-carousel]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
